import React from "react"
import CCMAdminComponent from "../components/CCMAdmin/CCMAdmin"

const CCMAdminView = () => <CCMAdminComponent />

export default CCMAdminView
